import React from 'react';

import * as styles from './headerSection.module.scss';
import { RichText } from '../richText/RichText';

interface IHeaderSectionProps {
  title?: string | null;
  description?: any | null;
  isH1?: boolean;
}

export const HeaderSection = ({ title, description, isH1 = false }: IHeaderSectionProps) => (
  <header className={styles.wrapper}>
    {isH1 ? <h1 className={styles.title}>{title}</h1> : <h2 className={styles.title}>{title}</h2>}
    <RichText value={description} className={styles.description} />
  </header>
);
